import React from 'react';
import moment from 'moment';
import { Container, Row, Col } from 'reactstrap';

const About = () => (
  <div className="AboutPage">
    <div
      style={{
        background: 'url(/assets/photos/LetoAndBandelli.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'left 20%',
        height: 400
      }}
      className="mb-4"
    />
    <Container className="px-md-5" style={{ maxWidth: 960 }}>
      <Row>
        <Col>
          <h2>About</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <figure className="figure">
            <img
              className="figure-img img-fluid"
              alt="Joe group selfie"
              src="/assets/photos/Oren_Group_Selfie.jpg"
            />
            <figcaption className="figure-caption">
              Joe with Anthony Masi, Rachel Belofsky, and Oren Peli, shooting on location in San Diego for "Unknown Dimension: The Story of Paranormal Activity."
            </figcaption>
          </figure>
        </Col>
        <Col>
          <figure className="figure">
            <img
              className="figure-img img-fluid"
              alt="Joe and Daphne"
              src="/assets/photos/DaphneRV_JoeBandelli.jpg"
            />
            <figcaption className="figure-caption">
              Joe discussing story and giving direction to Daphne Rubin-Vega on the set of the first episode of the critically acclaimed web series “Tuesday Nights.”
            </figcaption>
          </figure>
        </Col>
      </Row>
      <Row>
        <Col>
          <blockquote className="blockquote p-md-5 mr-lg-5 border-left-0">
            "Joe has a bright future ahead of him in the film industry, and hopefully we’ve given him more exposure for his immense talent."
            {' '}
            <footer className="blockquote-footer">
              <cite title="Source Title">Romero/Brooks</cite>
            </footer>
          </blockquote>
        </Col>
      </Row>
      <Row>
        <Col>
        <p>
            Joe Bandelli is a writer, director, producer, and CEO & founder of the production company Marylous' Boys. He has a background in film, television, new media, and live production. Dedicated to passionate storytelling, he is best known for his work on the found footage horror cult franchise, "Hell House LLC," and the horror documentary about the making of the "Paranormal Activity" franchise, "Unknown Dimension: The Story of Paranormal Activity." 
          </p>
          <p>
            Joe has written, directed, and produced content for Paramount+, Shudder, Syfy Network, and NBCUniversal. He also had the privilege of leading large production crews, where he helped create and develop the "Bud Light Dive Bar Tour" for Lady Gaga and Anheuser-Busch, served as the primary content producer and director for Salesforce's "Leading Through Change" Virtual Series, and developed the pilot for a 90’s nostalgic, throwback variety show on Syfy called, "Let's Get Cereal." 
          </p>
          <p>
            Being raised by a single mother in a multi-cultural environment has had a monumental impact, encouraging Joe to explore his natural imaginative nature. Influenced from a mixed, Egyptian and Italian background, has given Joe the gift of diversity and inclusion, first-hand. It is the foundation of which his artistry and creative nature is derived. His most recent work includes the fourth installment of the "Hell House LLC" franchise, "Hell House LLC Origins: The Carmichael Manor," and the upcoming supernatural horror feature, "825 Forest Road."
          </p>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <img
            alt="Joe Operating"
            className="figure-img img-fluid"
            src="/assets/photos/joecam1.jpg"
          />
          <figcaption className="figure-caption">
            Joe operating camera on-set at the National Association of Broadcasters convention (NAB) in Las Vegas, Nevada.
          </figcaption>
        </Col>
        <Col>
          <figure className="figure">
            <img
              alt="Joe has fun"
              className="figure-img img-fluid"
              src="/assets/photos/joehands1.jpg"
            />
            <figcaption className="figure-caption">
              Joe likes to have fun and is guaranteed to bring high energy and a sense of humor to every project he takes on.
            </figcaption>
          </figure>
        </Col>
      </Row>
      <Row>
        <Col>
          <blockquote className="blockquote text-right p-md-5 mr-0 ml-lg-5 border-left-0">
            "As an executive, Joe is a leader who proactively takes responsibility for his team and its remit within any organization."
            <footer className="blockquote-footer">
              <cite title="Source Title">Sam Kimball, Winship Media</cite>
            </footer>
          </blockquote>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col>
          <figure className="figure">
            <img
              alt="Joe and Andy"
              className="figure-img img-fluid"
              src="/assets/photos/JoeAndAndy.jpg"
            />
            <figcaption className="figure-caption pr-2">
              Joe with Cinematographer Andy Hamilton, on the streets of Brooklyn, NY, on the set of “Bumbloods.”
            </figcaption>
          </figure>
        </Col>
        <Col>
          <img
            alt="Joe Directing"
            className="figure-img img-fluid"
            src="/assets/photos/Clowns.jpg"
          />
          <figcaption className="figure-caption">
            Joe as the Hell House LLC Clown with Stephen Cognetti on the set of "Hell House LLC Origins: The Carmichael Manor."
          </figcaption>
        </Col>
      </Row>
    </Container>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/About.js